import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { fetchChatbotLeadsCount, fetchContactLeadsCount, fetchMortgageLeadsCount } from "../../actions/commonController"
import { toast } from "react-toastify"

const initialValue = {
    chatbotLeadCount: 0,
    contactLeadCount: 0,
    mortgageLeadCount: 0
}

const Overview = () => {
    const [loader, setLoader] = useState(true)
    const [overviewData, setOverviewData] = useState(initialValue)

    const loadData = async() => {
        try {
            setLoader(true)
            
            // Fetch all counts in parallel
            const [chatbotResult, contactResult, mortgageResult] = await Promise.all([
                fetchChatbotLeadsCount(),
                fetchContactLeadsCount(),
                fetchMortgageLeadsCount()
            ])
            
            setOverviewData({
                chatbotLeadCount: chatbotResult.status === "success" ? chatbotResult.data : 0,
                contactLeadCount: contactResult.status === "success" ? contactResult.data : 0,
                mortgageLeadCount: mortgageResult.status === "success" ? mortgageResult.data : 0
            })
            
            setLoader(false)
        } catch (err) {
            toast.error(err.message)
            setLoader(false)
        }
    }

    useEffect(() => {
        loadData()
    }, [])
    

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box">
                            <h4 className="page-title">
                                Welcome!
                                <Button style={{ marginLeft: "10px" }} onClick={loadData}>Click here to refresh</Button>
                            </h4>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xxl-4 col-sm-12">
                        <div className="card widget-flat text-bg-pink">
                            <div className="card-body">
                                <div className="float-end">
                                    <i className="ri-eye-line widget-icon"></i>
                                </div>
                                <h6 className="text-uppercase mt-0" title="Customers">
                                    Total Leads from Chatbot AI
                                </h6>
                                <h2 className="my-2">
                                    {
                                        loader ?
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        : overviewData?.chatbotLeadCount
                                    }
                                </h2>
                            </div>
                        </div>
                    </div>

                    <div className="col-xxl-4 col-sm-12">
                        <div className="card widget-flat text-bg-purple">
                            <div className="card-body">
                                <div className="float-end">
                                    <i className="ri-wallet-2-line widget-icon"></i>
                                </div>
                                <h6 className="text-uppercase mt-0" title="Customers">
                                    Total Leads from contact page
                                </h6>
                                <h2 className="my-2">
                                    {
                                        loader ?
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        : overviewData?.contactLeadCount
                                    }
                                </h2>
                            </div>
                        </div>
                    </div>

                    <div className="col-xxl-4 col-sm-12">
                        <div className="card widget-flat text-bg-secondary">
                            <div className="card-body">
                                <div className="float-end">
                                    <i className="ri-bank-line widget-icon"></i>
                                </div>
                                <h6 className="text-uppercase mt-0" title="Customers">Total Leads from Mortgage</h6>
                                <h2 className="my-2">
                                    {
                                        loader ?
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        : overviewData?.mortgageLeadCount
                                    }
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Overview